module.exports = __webpack_public_path__ + "img/2024-10-16b_1.d42953f4.jpg";